export const pathImages = `${import.meta.env.VITE_PATH_IMAGES}`;
export const pathIcons = `${import.meta.env.VITE_PATH_IMAGES}/icons`;
export const pathBackgrounds = `${import.meta.env.VITE_PATH_IMAGES}/backgrounds`;
export const pathTextures = `${pathBackgrounds}/textures`;
export const pathEvents = `${import.meta.env.VITE_PATH_IMAGES}/events`;
export const termsOfServiceUrl = `${import.meta.env.VITE_PPS_TERMS_OF_SERVICE_URL}`;
export const privacyPolicyUrl = `${import.meta.env.VITE_PPS_PRIVACY_POLICY_URL}`;
export const appVersion = `${import.meta.env.VITE_APP_VERSION}`;
export const supportEmail = `${import.meta.env.VITE_SUPPORT_EMAIL}`;
export const fbPage = `${import.meta.env.VITE_FB_PAGE}`;
export const discordLink = `${import.meta.env.VITE_DISCORD_LINK}`;
export const sentryDsn = `${import.meta.env.VITE_SENTRY_DSN ? import.meta.env.VITE_SENTRY_DSN : ""}`;
export const sentryEnvironment = `${import.meta.env.VITE_SENTRY_ENVIRONMENT ? import.meta.env.VITE_SENTRY_ENVIRONMENT : ""}`;
export const surveyUrl = `${import.meta.env.VITE_LOK_SURVEY_URL}`;
